module.exports = __webpack_public_path__ + "static/media/Basement.4fc2a05f.jpeg";